import { render, staticRenderFns } from "./dr-snippet-editor.vue?vue&type=template&id=e9ff312c"
import script from "./dr-snippet-editor.vue?vue&type=script&lang=js"
export * from "./dr-snippet-editor.vue?vue&type=script&lang=js"
import style0 from "./dr-snippet-editor.vue?vue&type=style&index=0&id=e9ff312c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports